var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorkNextArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E5",
    fillOpacity: 0,
    fillRule: "evenodd",
    d: "M.001 0H40v40H.001V0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M39.995 19.712L28.711 30.996l-.707-.708L38.293 20H.001v-1h38.291L28.004 8.711l.707-.706 11.284 11.284-.211.211.211.212z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkNextArrowIcon);
export default __webpack_public_path__ + "static/media/work-next-arrow-icon.4019477e1bc37d53f8ef026b99556db5.svg";
export { ForwardRef as ReactComponent };